import { DataType } from '@common/enums/data-type'

export class KnownPropertyTypes {
    public static map: { [id: string]: number } = {};
    private static toServicePropertyMap: { [id: string]: string } = {};
    private static fromServicePropertyMap: { [id: string]: string } = {};

    public static forValidationType(validationType: string): number {
        switch (validationType) {
            case "Duration":
                return DataType.STRING;
            case "Time":
                return DataType.DATE;
            case "MOSDateTime":
                return DataType.DATE;
            case "CheckBox":
                return DataType.BOOL;
            case "Text":
                return DataType.STRING;
            case "MOSAutomation":
                return DataType.STRING;
            case "StaffIDList":
                return DataType.STRING;
            case "Date":
                return DataType.DATE;
            default:
                throw "Validation Type mapping not implemented for " + validationType;
        }
    }

    public static for(property: string): number {
        return KnownPropertyTypes.map[property];
    }

    public static setFor(propertyTypes: { [id: string]: number }) {
        for (let property in propertyTypes) {
            KnownPropertyTypes.map[property] = propertyTypes[property];
        }
    }
}